/**
 * Frontend chrome label helper for Trade Finance Case Study Modal.
 *
 * Kept separate from modal-utils / modal-constants to avoid circular imports.
 */

/**
 * Resolve a hardcoded modal chrome label.
 *
 * Prefer PHP/WPML-localized values from `alteiaTfcsModalI18n` on the frontend.
 * Fall back to gettext so the editor and non-WPML installs still work.
 *
 * @param {string} key      CamelCase key from alteiaTfcsModalI18n.
 * @param {string} fallback English gettext fallback.
 * @return {string} Translated label.
 */
export function getModalChromeLabel( key, fallback ) {
	const labels =
		typeof window !== 'undefined' && window.alteiaTfcsModalI18n
			? window.alteiaTfcsModalI18n
			: null;

	if ( labels && typeof labels[ key ] === 'string' && labels[ key ] ) {
		return labels[ key ];
	}

	return fallback;
}
